import { useMemo } from 'react'

import {
  useGetWorkspaceSubscribeInformationQuery,
  useGetAvailablePlansQuery,
  useGetCustomerQuery,
} from '@sketch/gql-types'

export const useWorkspaceSubscribeInformation = (
  workspaceId: string,
  customerId: string
) => {
  const plansQuery = useGetAvailablePlansQuery({})

  const subscribeInformation = useGetWorkspaceSubscribeInformationQuery({
    variables: { identifier: workspaceId },
    fetchPolicy: 'network-only',
  })

  const customerPayment = useGetCustomerQuery({
    variables: { customerId },
    /**
     * We should always get fresh information on the workspace customer information
     * it might have different methods or setup intents stored from passed actions
     */
    fetchPolicy: 'network-only',
  })

  /**
   * The Memo exists to prevent infinite loops on effects
   * that might depend on this data
   */
  const data = useMemo(() => {
    if (
      !plansQuery.data ||
      !subscribeInformation.data ||
      !customerPayment.data
    ) {
      return undefined
    }

    const availablePlans = plansQuery.data.availablePlans || []

    return {
      availablePlans,
      ...subscribeInformation.data,
      ...customerPayment.data,
    }
  }, [customerPayment.data, plansQuery.data, subscribeInformation.data])

  return {
    loading:
      subscribeInformation.loading ||
      customerPayment.loading ||
      plansQuery.loading,
    error:
      subscribeInformation.error || customerPayment.error || plansQuery.error,
    data,
  }
}
